"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EhrLoginLogout = void 0;
const react_1 = __importDefault(require("react"));
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const banner_1 = __importDefault(require("@kyruus/banner"));
const button_1 = require("@kyruus/button");
const ThirdPartyBanners_1 = require("../../ThirdPartyBanners");
const EhrLoginLogout_styles_1 = require("./EhrLoginLogout.styles");
const prop_types_1 = require("prop-types");
const thirdPartyLoginUtils_1 = require("../../../lib/thirdPartyLoginUtils");
const thirdPartyLogin_1 = require("../../../lib/constants/thirdPartyLogin");
const Tracking_1 = require("../../../lib/constants/Tracking");
const EhrLoginLogout = ({ intl, loginProps, callbackProps = {}, track }) => {
    const { isLoggedIn, login, logout, errors = [], type } = loginProps;
    const isLoginEnabled = react_1.default.useMemo(() => !(0, isEmpty_1.default)(loginProps) && !(0, isEmpty_1.default)(login) && !(0, isEmpty_1.default)(logout), [loginProps, login, logout]);
    const handleLogin = react_1.default.useCallback((e) => {
        e.preventDefault();
        if (login.callback) {
            track(Tracking_1.userEvents.PATIENT_REG_EHR_LOGIN, { ehr: type });
            login.callback(callbackProps);
        }
    }, 
    // callbackProps is small enough that JSON.stringify won't be slow, lets us deep compare
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(callbackProps), login, track, type]);
    const handleLogout = react_1.default.useCallback((e) => {
        e.preventDefault();
        if (logout.callback) {
            logout.callback(callbackProps);
        }
    }, 
    // callbackProps is small enough that JSON.stringify won't be slow, lets us deep compare
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(callbackProps), logout]);
    if (!isLoginEnabled)
        return null;
    if (errors.length > 0) {
        const { description: messageText, action: actionText } = (0, thirdPartyLoginUtils_1.getErrorMessageWithIntl)({
            thirdPartyLoginProps: loginProps,
            intl
        });
        if (!messageText)
            return null;
        return (react_1.default.createElement(ThirdPartyBanners_1.AuthNBanner, { "data-testid": "auth-banner-error", description: messageText, action: actionText }, ({ description, action }) => (react_1.default.createElement(banner_1.default, { "data-testid": "auth-banner-error-button", type: "warning", icon: "!", action1Text: action, action1: action ? handleLogin : undefined }, description))));
    }
    return isLoggedIn ? (react_1.default.createElement(ThirdPartyBanners_1.AuthNBanner, { "data-testid": "auth-banner-logout", description: logout.description, action: logout.action }, ({ description, action }) => (react_1.default.createElement(banner_1.default, { "data-testid": "auth-banner-logout-button", type: "success", icon: "check", action1Text: action, action1: handleLogout }, description)))) : (react_1.default.createElement(ThirdPartyBanners_1.AuthNBanner, { "data-testid": "auth-banner-login", header: react_1.default.createElement(EhrLoginLogout_styles_1.LoginHeader, null, login.header), description: react_1.default.createElement(EhrLoginLogout_styles_1.LoginDescription, null, login.description), action: react_1.default.createElement(button_1.ButtonLink, { mode: "primary", "data-testid": "auth-banner-login-button", href: login.url, onClick: handleLogin }, login.action), separatorContent: login.separator }));
};
exports.EhrLoginLogout = EhrLoginLogout;
exports.EhrLoginLogout.propTypes = {
    /* eslint-disable react/forbid-prop-types */
    intl: (0, prop_types_1.shape)({
        locale: prop_types_1.string.isRequired,
        formatMessage: prop_types_1.func.isRequired
    }).isRequired,
    loginProps: (0, prop_types_1.shape)({
        isLoggedIn: prop_types_1.bool.isRequired,
        login: (0, prop_types_1.shape)({
            url: prop_types_1.string,
            callback: prop_types_1.func.isRequired,
            header: prop_types_1.string,
            description: prop_types_1.string,
            action: prop_types_1.string.isRequired,
            separator: prop_types_1.string
        }).isRequired,
        logout: (0, prop_types_1.shape)({
            url: prop_types_1.string,
            callback: prop_types_1.func.isRequired,
            header: prop_types_1.string,
            description: prop_types_1.string,
            action: prop_types_1.string.isRequired,
            separator: prop_types_1.string
        }).isRequired,
        errors: (0, prop_types_1.arrayOf)((0, prop_types_1.oneOf)(Object.values(thirdPartyLogin_1.ERROR))),
        type: prop_types_1.string.isRequired
    }),
    callbackProps: prop_types_1.object,
    track: prop_types_1.func.isRequired
};
//# sourceMappingURL=EhrLoginLogout.js.map